import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AsyncPaginate } from "react-select-async-paginate";

export default function ModalEditInUpdate(props) {
  const { lang, functions, proxy, database } = useSelector((state) => state);
  const {
    data,
    fields,
    handleChangeData,
    pk,
    setRefreshPage,
    setRenderEditInUpdate,
    displayField,
    dataShowTable,
    setDataDelete,
  } = props;
  console.log("dataShowTable", props);
  const [fieldsMapped, setFieldsMapped] = useState([]);
  return (
    <>
      <div
        class="modal fade"
        id="renderEditInUpdate"
        tabindex="-1"
        aria-labelledby="renderEditInUpdate"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog">
          <div className="modal-content custome">
            <div className="modal-header justify-content-end">
              <span style={{ fontSize: "18px" }}>{lang["edit"]}</span>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                onClick={() => setRenderEditInUpdate(false)}
              >
                &times;
              </button>
            </div>
            <div
              className="modal-body"
              style={{
                height: "70vh",
                overflowY: "auto",
                overflowX: "unset",
              }}
            >
              <form
                className=""
                style={{
                  padding: "5px 5em",
                }}
              >
                {fields.map((field, index) => {
                  const {
                    DATATYPE,
                    value,
                    label,
                    is_name,
                    display,
                    child_fields,
                  } = field;
                  console.log("WHATTSS", field, data);

                  return (
                    <div className="mb-3">
                      <label className="form-label">{is_name || label}</label>
                      <input
                        className="form-control"
                        type={DATATYPE === "TEXT" ? "text" : "number"}
                        defaultValue={data[value]}
                        readOnly={value === pk ? true : display ? false : true}
                        onChange={(e) =>
                          handleChangeData(
                            e.target.value,
                            field,
                            data,
                            data.index,
                            true
                          )
                        }
                      />
                    </div>
                  );
                })}
              </form>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => setRenderEditInUpdate(false)}
              >
                {lang["btn.close"]}
              </button>
              <button
                type="button"
                class="btn btn-primary"
                data-dismiss="modal"
                onClick={() => {
                  setRefreshPage((prev) => prev + 1);
                  setRenderEditInUpdate(false);
                }}
              >
                {lang["btn.update"]}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
